import { lazy, Suspense, useContext, useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
// import ThemeSettings from 'src/components/ThemeSettings';
import { SidebarContext } from 'src/contexts/SidebarContext';
import Sidebar from './Sidebar';
import Header from './Header';
import { SIDEBAR_EXPANDED_WIDTH } from './constants';

const GlobalJarvisPopup = lazy(() => import('src/components/GlobalJarvisPopup'));
const PhoneRealtimeProvider = lazy(() => import('src/components/PhoneRealtimeProvider'));

const CollapsedSidebarLayout = () => {
  const theme = useTheme();
  const { sidebarExpanded } = useContext(SidebarContext);
  const [jarvisReady, setJarvisReady] = useState(false);
  const sidebarWidth = sidebarExpanded
    ? SIDEBAR_EXPANDED_WIDTH
    : theme.density.sidebarRailWidth;

  useEffect(() => {
    const enableJarvis = () => setJarvisReady(true);
    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(enableJarvis, { timeout: 1500 });
      return () => window.cancelIdleCallback(idleId);
    }
    const timeoutId = window.setTimeout(enableJarvis, 0);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <Box
        sx={{
          '--app-sidebar-width': `${sidebarWidth}px`,
          flex: 1,
          height: '100%',

          '.Mui-FixedWrapper': {
            '.MuiDrawer-root.MuiDrawer-docked': {
                '.MuiPaper-root': {
                left: 'var(--app-sidebar-width)'
              }
            }
          }
        }}
      >
        <Header />
        <Sidebar />
        <Box
          sx={{
            position: 'relative',
            zIndex: 5,
            display: 'block',
            flex: 1,
            pt: `${theme.header.height}`,
            [theme.breakpoints.up('md')]: {
              ml: 'var(--app-sidebar-width)'
            },
            transition: theme.transitions.create('margin-left', {
              duration: theme.transitions.duration.shorter
            })
          }}
        >
          <Box display="block">
            <Outlet />
          </Box>
          <Suspense fallback={null}>
            <PhoneRealtimeProvider />
          </Suspense>
          {jarvisReady ? (
            <Suspense fallback={null}>
              <GlobalJarvisPopup />
            </Suspense>
          ) : null}
          {/* <ThemeSettings /> */}
        </Box>
      </Box>
    </>
  );
};

export default CollapsedSidebarLayout;
